import template from './applied-filters-view.html';

class AppliedFiltersViewController {
  constructor() {
    'ngInject';

  }

  $onInit() {
  }

  $onChanges() {
  }

  clickClear(filter) {
    filter.value = '';

    this.filterChanged();
  }

  clickClearAll() {
    this.filters.forEach((filter) => {
      filter.value = '';
    });

    this.filterChanged();
  }
}

/**
 * take filters : [{label, value, prop}]
 */
export default {
  template,
  controller: AppliedFiltersViewController,
  controllerAs: 'afVm',
  bindings: {
    filters: '<',
    filterChanged: '&',
  },
};
